"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.filter.js");
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));
var _gAxios = _interopRequireWildcard(require("@gravity/g-axios"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_deeqi03si() {
  var path = "/codebuild/output/src609432752/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/calendar/lib/actions.js";
  var hash = "0e51cd9a03abb23496b7fb482b909969d324c66c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src609432752/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/calendar/lib/actions.js",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 34
        },
        end: {
          line: 6,
          column: 2
        }
      },
      "1": {
        start: {
          line: 3,
          column: 48
        },
        end: {
          line: 6,
          column: 1
        }
      },
      "2": {
        start: {
          line: 8,
          column: 28
        },
        end: {
          line: 11,
          column: 2
        }
      },
      "3": {
        start: {
          line: 8,
          column: 42
        },
        end: {
          line: 11,
          column: 1
        }
      },
      "4": {
        start: {
          line: 13,
          column: 31
        },
        end: {
          line: 18,
          column: 2
        }
      },
      "5": {
        start: {
          line: 13,
          column: 54
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "6": {
        start: {
          line: 20,
          column: 35
        },
        end: {
          line: 24,
          column: 2
        }
      },
      "7": {
        start: {
          line: 20,
          column: 54
        },
        end: {
          line: 24,
          column: 1
        }
      },
      "8": {
        start: {
          line: 26,
          column: 34
        },
        end: {
          line: 32,
          column: 2
        }
      },
      "9": {
        start: {
          line: 26,
          column: 66
        },
        end: {
          line: 32,
          column: 1
        }
      },
      "10": {
        start: {
          line: 34,
          column: 32
        },
        end: {
          line: 41,
          column: 2
        }
      },
      "11": {
        start: {
          line: 34,
          column: 69
        },
        end: {
          line: 41,
          column: 1
        }
      },
      "12": {
        start: {
          line: 43,
          column: 27
        },
        end: {
          line: 45,
          column: 2
        }
      },
      "13": {
        start: {
          line: 43,
          column: 34
        },
        end: {
          line: 45,
          column: 1
        }
      },
      "14": {
        start: {
          line: 47,
          column: 39
        },
        end: {
          line: 52,
          column: 2
        }
      },
      "15": {
        start: {
          line: 47,
          column: 79
        },
        end: {
          line: 52,
          column: 1
        }
      },
      "16": {
        start: {
          line: 54,
          column: 43
        },
        end: {
          line: 58,
          column: 2
        }
      },
      "17": {
        start: {
          line: 54,
          column: 62
        },
        end: {
          line: 58,
          column: 1
        }
      },
      "18": {
        start: {
          line: 66,
          column: 36
        },
        end: {
          line: 92,
          column: 1
        }
      },
      "19": {
        start: {
          line: 67,
          column: 23
        },
        end: {
          line: 67,
          column: 64
        }
      },
      "20": {
        start: {
          line: 68,
          column: 28
        },
        end: {
          line: 68,
          column: 92
        }
      },
      "21": {
        start: {
          line: 69,
          column: 28
        },
        end: {
          line: 71,
          column: 8
        }
      },
      "22": {
        start: {
          line: 72,
          column: 26
        },
        end: {
          line: 72,
          column: 111
        }
      },
      "23": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 80,
          column: 5
        }
      },
      "24": {
        start: {
          line: 78,
          column: 8
        },
        end: {
          line: 78,
          column: 97
        }
      },
      "25": {
        start: {
          line: 82,
          column: 20
        },
        end: {
          line: 90,
          column: 14
        }
      },
      "26": {
        start: {
          line: 91,
          column: 2
        },
        end: {
          line: 91,
          column: 42
        }
      },
      "27": {
        start: {
          line: 94,
          column: 17
        },
        end: {
          line: 94,
          column: 50
        }
      },
      "28": {
        start: {
          line: 94,
          column: 27
        },
        end: {
          line: 94,
          column: 50
        }
      },
      "29": {
        start: {
          line: 101,
          column: 19
        },
        end: {
          line: 124,
          column: 1
        }
      },
      "30": {
        start: {
          line: 101,
          column: 55
        },
        end: {
          line: 124,
          column: 1
        }
      },
      "31": {
        start: {
          line: 103,
          column: 2
        },
        end: {
          line: 103,
          column: 49
        }
      },
      "32": {
        start: {
          line: 106,
          column: 2
        },
        end: {
          line: 123,
          column: 7
        }
      },
      "33": {
        start: {
          line: 113,
          column: 6
        },
        end: {
          line: 116,
          column: 7
        }
      },
      "34": {
        start: {
          line: 114,
          column: 8
        },
        end: {
          line: 114,
          column: 68
        }
      },
      "35": {
        start: {
          line: 115,
          column: 8
        },
        end: {
          line: 115,
          column: 29
        }
      },
      "36": {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 117,
          column: 21
        }
      },
      "37": {
        start: {
          line: 120,
          column: 6
        },
        end: {
          line: 120,
          column: 37
        }
      },
      "38": {
        start: {
          line: 121,
          column: 6
        },
        end: {
          line: 121,
          column: 102
        }
      },
      "39": {
        start: {
          line: 122,
          column: 6
        },
        end: {
          line: 122,
          column: 22
        }
      },
      "40": {
        start: {
          line: 136,
          column: 30
        },
        end: {
          line: 201,
          column: 1
        }
      },
      "41": {
        start: {
          line: 136,
          column: 51
        },
        end: {
          line: 201,
          column: 1
        }
      },
      "42": {
        start: {
          line: 138,
          column: 2
        },
        end: {
          line: 138,
          column: 34
        }
      },
      "43": {
        start: {
          line: 140,
          column: 73
        },
        end: {
          line: 140,
          column: 80
        }
      },
      "44": {
        start: {
          line: 143,
          column: 31
        },
        end: {
          line: 143,
          column: 86
        }
      },
      "45": {
        start: {
          line: 149,
          column: 25
        },
        end: {
          line: 159,
          column: 5
        }
      },
      "46": {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 159,
          column: 5
        }
      },
      "47": {
        start: {
          line: 163,
          column: 29
        },
        end: {
          line: 173,
          column: 5
        }
      },
      "48": {
        start: {
          line: 164,
          column: 4
        },
        end: {
          line: 173,
          column: 5
        }
      },
      "49": {
        start: {
          line: 175,
          column: 2
        },
        end: {
          line: 200,
          column: 7
        }
      },
      "50": {
        start: {
          line: 179,
          column: 28
        },
        end: {
          line: 179,
          column: 48
        }
      },
      "51": {
        start: {
          line: 180,
          column: 44
        },
        end: {
          line: 180,
          column: 67
        }
      },
      "52": {
        start: {
          line: 181,
          column: 8
        },
        end: {
          line: 181,
          column: 44
        }
      },
      "53": {
        start: {
          line: 182,
          column: 8
        },
        end: {
          line: 182,
          column: 38
        }
      },
      "54": {
        start: {
          line: 184,
          column: 8
        },
        end: {
          line: 190,
          column: 9
        }
      },
      "55": {
        start: {
          line: 185,
          column: 24
        },
        end: {
          line: 185,
          column: 81
        }
      },
      "56": {
        start: {
          line: 186,
          column: 10
        },
        end: {
          line: 189,
          column: 12
        }
      },
      "57": {
        start: {
          line: 191,
          column: 22
        },
        end: {
          line: 191,
          column: 92
        }
      },
      "58": {
        start: {
          line: 192,
          column: 8
        },
        end: {
          line: 192,
          column: 67
        }
      },
      "59": {
        start: {
          line: 193,
          column: 8
        },
        end: {
          line: 193,
          column: 20
        }
      },
      "60": {
        start: {
          line: 197,
          column: 6
        },
        end: {
          line: 197,
          column: 37
        }
      },
      "61": {
        start: {
          line: 198,
          column: 6
        },
        end: {
          line: 198,
          column: 102
        }
      },
      "62": {
        start: {
          line: 199,
          column: 6
        },
        end: {
          line: 199,
          column: 22
        }
      },
      "63": {
        start: {
          line: 213,
          column: 34
        },
        end: {
          line: 278,
          column: 1
        }
      },
      "64": {
        start: {
          line: 213,
          column: 55
        },
        end: {
          line: 278,
          column: 1
        }
      },
      "65": {
        start: {
          line: 215,
          column: 2
        },
        end: {
          line: 215,
          column: 34
        }
      },
      "66": {
        start: {
          line: 217,
          column: 65
        },
        end: {
          line: 217,
          column: 72
        }
      },
      "67": {
        start: {
          line: 218,
          column: 21
        },
        end: {
          line: 218,
          column: 31
        }
      },
      "68": {
        start: {
          line: 220,
          column: 31
        },
        end: {
          line: 220,
          column: 86
        }
      },
      "69": {
        start: {
          line: 221,
          column: 21
        },
        end: {
          line: 221,
          column: 84
        }
      },
      "70": {
        start: {
          line: 226,
          column: 25
        },
        end: {
          line: 236,
          column: 5
        }
      },
      "71": {
        start: {
          line: 227,
          column: 4
        },
        end: {
          line: 236,
          column: 5
        }
      },
      "72": {
        start: {
          line: 240,
          column: 29
        },
        end: {
          line: 250,
          column: 5
        }
      },
      "73": {
        start: {
          line: 241,
          column: 4
        },
        end: {
          line: 250,
          column: 5
        }
      },
      "74": {
        start: {
          line: 252,
          column: 2
        },
        end: {
          line: 277,
          column: 7
        }
      },
      "75": {
        start: {
          line: 256,
          column: 28
        },
        end: {
          line: 256,
          column: 48
        }
      },
      "76": {
        start: {
          line: 257,
          column: 44
        },
        end: {
          line: 257,
          column: 67
        }
      },
      "77": {
        start: {
          line: 258,
          column: 8
        },
        end: {
          line: 258,
          column: 44
        }
      },
      "78": {
        start: {
          line: 259,
          column: 8
        },
        end: {
          line: 259,
          column: 38
        }
      },
      "79": {
        start: {
          line: 261,
          column: 8
        },
        end: {
          line: 267,
          column: 9
        }
      },
      "80": {
        start: {
          line: 262,
          column: 24
        },
        end: {
          line: 262,
          column: 85
        }
      },
      "81": {
        start: {
          line: 263,
          column: 10
        },
        end: {
          line: 266,
          column: 12
        }
      },
      "82": {
        start: {
          line: 268,
          column: 22
        },
        end: {
          line: 268,
          column: 92
        }
      },
      "83": {
        start: {
          line: 269,
          column: 8
        },
        end: {
          line: 269,
          column: 67
        }
      },
      "84": {
        start: {
          line: 270,
          column: 8
        },
        end: {
          line: 270,
          column: 20
        }
      },
      "85": {
        start: {
          line: 274,
          column: 6
        },
        end: {
          line: 274,
          column: 37
        }
      },
      "86": {
        start: {
          line: 275,
          column: 6
        },
        end: {
          line: 275,
          column: 102
        }
      },
      "87": {
        start: {
          line: 276,
          column: 6
        },
        end: {
          line: 276,
          column: 22
        }
      },
      "88": {
        start: {
          line: 287,
          column: 29
        },
        end: {
          line: 292,
          column: 1
        }
      },
      "89": {
        start: {
          line: 287,
          column: 75
        },
        end: {
          line: 292,
          column: 1
        }
      },
      "90": {
        start: {
          line: 289,
          column: 2
        },
        end: {
          line: 289,
          column: 54
        }
      },
      "91": {
        start: {
          line: 291,
          column: 2
        },
        end: {
          line: 291,
          column: 92
        }
      },
      "92": {
        start: {
          line: 299,
          column: 18
        },
        end: {
          line: 328,
          column: 1
        }
      },
      "93": {
        start: {
          line: 299,
          column: 74
        },
        end: {
          line: 328,
          column: 1
        }
      },
      "94": {
        start: {
          line: 301,
          column: 2
        },
        end: {
          line: 301,
          column: 34
        }
      },
      "95": {
        start: {
          line: 303,
          column: 20
        },
        end: {
          line: 303,
          column: 40
        }
      },
      "96": {
        start: {
          line: 305,
          column: 2
        },
        end: {
          line: 327,
          column: 7
        }
      },
      "97": {
        start: {
          line: 317,
          column: 6
        },
        end: {
          line: 320,
          column: 7
        }
      },
      "98": {
        start: {
          line: 318,
          column: 8
        },
        end: {
          line: 318,
          column: 80
        }
      },
      "99": {
        start: {
          line: 319,
          column: 8
        },
        end: {
          line: 319,
          column: 29
        }
      },
      "100": {
        start: {
          line: 321,
          column: 6
        },
        end: {
          line: 321,
          column: 21
        }
      },
      "101": {
        start: {
          line: 324,
          column: 6
        },
        end: {
          line: 324,
          column: 37
        }
      },
      "102": {
        start: {
          line: 325,
          column: 6
        },
        end: {
          line: 325,
          column: 102
        }
      },
      "103": {
        start: {
          line: 326,
          column: 6
        },
        end: {
          line: 326,
          column: 22
        }
      },
      "104": {
        start: {
          line: 330,
          column: 16
        },
        end: {
          line: 358,
          column: 1
        }
      },
      "105": {
        start: {
          line: 330,
          column: 77
        },
        end: {
          line: 358,
          column: 1
        }
      },
      "106": {
        start: {
          line: 332,
          column: 2
        },
        end: {
          line: 332,
          column: 53
        }
      },
      "107": {
        start: {
          line: 335,
          column: 2
        },
        end: {
          line: 357,
          column: 7
        }
      },
      "108": {
        start: {
          line: 347,
          column: 6
        },
        end: {
          line: 350,
          column: 7
        }
      },
      "109": {
        start: {
          line: 348,
          column: 8
        },
        end: {
          line: 348,
          column: 83
        }
      },
      "110": {
        start: {
          line: 349,
          column: 8
        },
        end: {
          line: 349,
          column: 29
        }
      },
      "111": {
        start: {
          line: 351,
          column: 6
        },
        end: {
          line: 351,
          column: 21
        }
      },
      "112": {
        start: {
          line: 354,
          column: 6
        },
        end: {
          line: 354,
          column: 37
        }
      },
      "113": {
        start: {
          line: 355,
          column: 6
        },
        end: {
          line: 355,
          column: 102
        }
      },
      "114": {
        start: {
          line: 356,
          column: 6
        },
        end: {
          line: 356,
          column: 22
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 34
          },
          end: {
            line: 3,
            column: 35
          }
        },
        loc: {
          start: {
            line: 3,
            column: 48
          },
          end: {
            line: 6,
            column: 1
          }
        },
        line: 3
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 8,
            column: 28
          },
          end: {
            line: 8,
            column: 29
          }
        },
        loc: {
          start: {
            line: 8,
            column: 42
          },
          end: {
            line: 11,
            column: 1
          }
        },
        line: 8
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 13,
            column: 31
          },
          end: {
            line: 13,
            column: 32
          }
        },
        loc: {
          start: {
            line: 13,
            column: 54
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 13
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 20,
            column: 35
          },
          end: {
            line: 20,
            column: 36
          }
        },
        loc: {
          start: {
            line: 20,
            column: 54
          },
          end: {
            line: 24,
            column: 1
          }
        },
        line: 20
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 26,
            column: 34
          },
          end: {
            line: 26,
            column: 35
          }
        },
        loc: {
          start: {
            line: 26,
            column: 66
          },
          end: {
            line: 32,
            column: 1
          }
        },
        line: 26
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 34,
            column: 32
          },
          end: {
            line: 34,
            column: 33
          }
        },
        loc: {
          start: {
            line: 34,
            column: 69
          },
          end: {
            line: 41,
            column: 1
          }
        },
        line: 34
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 43,
            column: 27
          },
          end: {
            line: 43,
            column: 28
          }
        },
        loc: {
          start: {
            line: 43,
            column: 34
          },
          end: {
            line: 45,
            column: 1
          }
        },
        line: 43
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 47,
            column: 39
          },
          end: {
            line: 47,
            column: 40
          }
        },
        loc: {
          start: {
            line: 47,
            column: 79
          },
          end: {
            line: 52,
            column: 1
          }
        },
        line: 47
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 54,
            column: 43
          },
          end: {
            line: 54,
            column: 44
          }
        },
        loc: {
          start: {
            line: 54,
            column: 62
          },
          end: {
            line: 58,
            column: 1
          }
        },
        line: 54
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 66,
            column: 36
          },
          end: {
            line: 66,
            column: 37
          }
        },
        loc: {
          start: {
            line: 66,
            column: 102
          },
          end: {
            line: 92,
            column: 1
          }
        },
        line: 66
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 77,
            column: 6
          },
          end: {
            line: 77,
            column: 7
          }
        },
        loc: {
          start: {
            line: 78,
            column: 8
          },
          end: {
            line: 78,
            column: 97
          }
        },
        line: 78
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 94,
            column: 17
          },
          end: {
            line: 94,
            column: 18
          }
        },
        loc: {
          start: {
            line: 94,
            column: 27
          },
          end: {
            line: 94,
            column: 50
          }
        },
        line: 94
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 101,
            column: 19
          },
          end: {
            line: 101,
            column: 20
          }
        },
        loc: {
          start: {
            line: 101,
            column: 55
          },
          end: {
            line: 124,
            column: 1
          }
        },
        line: 101
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 101,
            column: 55
          },
          end: {
            line: 101,
            column: 56
          }
        },
        loc: {
          start: {
            line: 101,
            column: 67
          },
          end: {
            line: 124,
            column: 1
          }
        },
        line: 101
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 112,
            column: 10
          },
          end: {
            line: 112,
            column: 11
          }
        },
        loc: {
          start: {
            line: 112,
            column: 22
          },
          end: {
            line: 118,
            column: 5
          }
        },
        line: 112
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 119,
            column: 11
          },
          end: {
            line: 119,
            column: 12
          }
        },
        loc: {
          start: {
            line: 119,
            column: 23
          },
          end: {
            line: 123,
            column: 5
          }
        },
        line: 119
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 136,
            column: 30
          },
          end: {
            line: 136,
            column: 31
          }
        },
        loc: {
          start: {
            line: 136,
            column: 51
          },
          end: {
            line: 201,
            column: 1
          }
        },
        line: 136
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 136,
            column: 51
          },
          end: {
            line: 136,
            column: 52
          }
        },
        loc: {
          start: {
            line: 136,
            column: 63
          },
          end: {
            line: 201,
            column: 1
          }
        },
        line: 136
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 149,
            column: 25
          },
          end: {
            line: 149,
            column: 26
          }
        },
        loc: {
          start: {
            line: 150,
            column: 4
          },
          end: {
            line: 159,
            column: 5
          }
        },
        line: 150
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 163,
            column: 29
          },
          end: {
            line: 163,
            column: 30
          }
        },
        loc: {
          start: {
            line: 164,
            column: 4
          },
          end: {
            line: 173,
            column: 5
          }
        },
        line: 164
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 178,
            column: 19
          },
          end: {
            line: 178,
            column: 20
          }
        },
        loc: {
          start: {
            line: 178,
            column: 60
          },
          end: {
            line: 194,
            column: 7
          }
        },
        line: 178
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 196,
            column: 11
          },
          end: {
            line: 196,
            column: 12
          }
        },
        loc: {
          start: {
            line: 196,
            column: 23
          },
          end: {
            line: 200,
            column: 5
          }
        },
        line: 196
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 213,
            column: 34
          },
          end: {
            line: 213,
            column: 35
          }
        },
        loc: {
          start: {
            line: 213,
            column: 55
          },
          end: {
            line: 278,
            column: 1
          }
        },
        line: 213
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 213,
            column: 55
          },
          end: {
            line: 213,
            column: 56
          }
        },
        loc: {
          start: {
            line: 213,
            column: 79
          },
          end: {
            line: 278,
            column: 1
          }
        },
        line: 213
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 226,
            column: 25
          },
          end: {
            line: 226,
            column: 26
          }
        },
        loc: {
          start: {
            line: 227,
            column: 4
          },
          end: {
            line: 236,
            column: 5
          }
        },
        line: 227
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 240,
            column: 29
          },
          end: {
            line: 240,
            column: 30
          }
        },
        loc: {
          start: {
            line: 241,
            column: 4
          },
          end: {
            line: 250,
            column: 5
          }
        },
        line: 241
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 255,
            column: 19
          },
          end: {
            line: 255,
            column: 20
          }
        },
        loc: {
          start: {
            line: 255,
            column: 60
          },
          end: {
            line: 271,
            column: 7
          }
        },
        line: 255
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 273,
            column: 11
          },
          end: {
            line: 273,
            column: 12
          }
        },
        loc: {
          start: {
            line: 273,
            column: 23
          },
          end: {
            line: 277,
            column: 5
          }
        },
        line: 273
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 287,
            column: 29
          },
          end: {
            line: 287,
            column: 30
          }
        },
        loc: {
          start: {
            line: 287,
            column: 75
          },
          end: {
            line: 292,
            column: 1
          }
        },
        line: 287
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 287,
            column: 75
          },
          end: {
            line: 287,
            column: 76
          }
        },
        loc: {
          start: {
            line: 287,
            column: 87
          },
          end: {
            line: 292,
            column: 1
          }
        },
        line: 287
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 299,
            column: 18
          },
          end: {
            line: 299,
            column: 19
          }
        },
        loc: {
          start: {
            line: 299,
            column: 74
          },
          end: {
            line: 328,
            column: 1
          }
        },
        line: 299
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 299,
            column: 74
          },
          end: {
            line: 299,
            column: 75
          }
        },
        loc: {
          start: {
            line: 299,
            column: 98
          },
          end: {
            line: 328,
            column: 1
          }
        },
        line: 299
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 316,
            column: 10
          },
          end: {
            line: 316,
            column: 11
          }
        },
        loc: {
          start: {
            line: 316,
            column: 22
          },
          end: {
            line: 322,
            column: 5
          }
        },
        line: 316
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 323,
            column: 11
          },
          end: {
            line: 323,
            column: 12
          }
        },
        loc: {
          start: {
            line: 323,
            column: 23
          },
          end: {
            line: 327,
            column: 5
          }
        },
        line: 323
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 330,
            column: 16
          },
          end: {
            line: 330,
            column: 17
          }
        },
        loc: {
          start: {
            line: 330,
            column: 77
          },
          end: {
            line: 358,
            column: 1
          }
        },
        line: 330
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 330,
            column: 77
          },
          end: {
            line: 330,
            column: 78
          }
        },
        loc: {
          start: {
            line: 330,
            column: 101
          },
          end: {
            line: 358,
            column: 1
          }
        },
        line: 330
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 346,
            column: 10
          },
          end: {
            line: 346,
            column: 11
          }
        },
        loc: {
          start: {
            line: 346,
            column: 22
          },
          end: {
            line: 352,
            column: 5
          }
        },
        line: 346
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 353,
            column: 11
          },
          end: {
            line: 353,
            column: 12
          }
        },
        loc: {
          start: {
            line: 353,
            column: 23
          },
          end: {
            line: 357,
            column: 5
          }
        },
        line: 353
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 66,
            column: 58
          },
          end: {
            line: 66,
            column: 77
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 66,
            column: 75
          },
          end: {
            line: 66,
            column: 77
          }
        }],
        line: 66
      },
      "1": {
        loc: {
          start: {
            line: 67,
            column: 23
          },
          end: {
            line: 67,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 67,
            column: 35
          },
          end: {
            line: 67,
            column: 59
          }
        }, {
          start: {
            line: 67,
            column: 62
          },
          end: {
            line: 67,
            column: 64
          }
        }],
        line: 67
      },
      "2": {
        loc: {
          start: {
            line: 68,
            column: 28
          },
          end: {
            line: 68,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 68,
            column: 50
          },
          end: {
            line: 68,
            column: 87
          }
        }, {
          start: {
            line: 68,
            column: 90
          },
          end: {
            line: 68,
            column: 92
          }
        }],
        line: 68
      },
      "3": {
        loc: {
          start: {
            line: 69,
            column: 28
          },
          end: {
            line: 71,
            column: 8
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 70,
            column: 6
          },
          end: {
            line: 70,
            column: 55
          }
        }, {
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 71,
            column: 8
          }
        }],
        line: 69
      },
      "4": {
        loc: {
          start: {
            line: 72,
            column: 26
          },
          end: {
            line: 72,
            column: 111
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 72,
            column: 45
          },
          end: {
            line: 72,
            column: 83
          }
        }, {
          start: {
            line: 72,
            column: 86
          },
          end: {
            line: 72,
            column: 111
          }
        }],
        line: 72
      },
      "5": {
        loc: {
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 80,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 4
          },
          end: {
            line: 75,
            column: 18
          }
        }, {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 80,
            column: 5
          }
        }],
        line: 75
      },
      "6": {
        loc: {
          start: {
            line: 78,
            column: 8
          },
          end: {
            line: 78,
            column: 97
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 78,
            column: 36
          },
          end: {
            line: 78,
            column: 86
          }
        }, {
          start: {
            line: 78,
            column: 89
          },
          end: {
            line: 78,
            column: 97
          }
        }],
        line: 78
      },
      "7": {
        loc: {
          start: {
            line: 91,
            column: 9
          },
          end: {
            line: 91,
            column: 41
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 91,
            column: 21
          },
          end: {
            line: 91,
            column: 36
          }
        }, {
          start: {
            line: 91,
            column: 39
          },
          end: {
            line: 91,
            column: 41
          }
        }],
        line: 91
      },
      "8": {
        loc: {
          start: {
            line: 101,
            column: 39
          },
          end: {
            line: 101,
            column: 50
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 101,
            column: 48
          },
          end: {
            line: 101,
            column: 50
          }
        }],
        line: 101
      },
      "9": {
        loc: {
          start: {
            line: 107,
            column: 27
          },
          end: {
            line: 107,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 107,
            column: 75
          },
          end: {
            line: 107,
            column: 84
          }
        }, {
          start: {
            line: 107,
            column: 87
          },
          end: {
            line: 107,
            column: 89
          }
        }],
        line: 107
      },
      "10": {
        loc: {
          start: {
            line: 107,
            column: 27
          },
          end: {
            line: 107,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 107,
            column: 27
          },
          end: {
            line: 107,
            column: 40
          }
        }, {
          start: {
            line: 107,
            column: 44
          },
          end: {
            line: 107,
            column: 72
          }
        }],
        line: 107
      },
      "11": {
        loc: {
          start: {
            line: 113,
            column: 6
          },
          end: {
            line: 116,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 113,
            column: 6
          },
          end: {
            line: 116,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 113
      },
      "12": {
        loc: {
          start: {
            line: 113,
            column: 10
          },
          end: {
            line: 113,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 113,
            column: 10
          },
          end: {
            line: 113,
            column: 32
          }
        }, {
          start: {
            line: 113,
            column: 36
          },
          end: {
            line: 113,
            column: 57
          }
        }],
        line: 113
      },
      "13": {
        loc: {
          start: {
            line: 143,
            column: 31
          },
          end: {
            line: 143,
            column: 86
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 143,
            column: 60
          },
          end: {
            line: 143,
            column: 62
          }
        }, {
          start: {
            line: 143,
            column: 65
          },
          end: {
            line: 143,
            column: 86
          }
        }],
        line: 143
      },
      "14": {
        loc: {
          start: {
            line: 151,
            column: 29
          },
          end: {
            line: 151,
            column: 91
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 151,
            column: 77
          },
          end: {
            line: 151,
            column: 86
          }
        }, {
          start: {
            line: 151,
            column: 89
          },
          end: {
            line: 151,
            column: 91
          }
        }],
        line: 151
      },
      "15": {
        loc: {
          start: {
            line: 151,
            column: 29
          },
          end: {
            line: 151,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 151,
            column: 29
          },
          end: {
            line: 151,
            column: 42
          }
        }, {
          start: {
            line: 151,
            column: 46
          },
          end: {
            line: 151,
            column: 74
          }
        }],
        line: 151
      },
      "16": {
        loc: {
          start: {
            line: 152,
            column: 8
          },
          end: {
            line: 152,
            column: 91
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 152,
            column: 36
          },
          end: {
            line: 152,
            column: 86
          }
        }, {
          start: {
            line: 152,
            column: 89
          },
          end: {
            line: 152,
            column: 91
          }
        }],
        line: 152
      },
      "17": {
        loc: {
          start: {
            line: 153,
            column: 33
          },
          end: {
            line: 153,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 153,
            column: 44
          },
          end: {
            line: 153,
            column: 67
          }
        }, {
          start: {
            line: 153,
            column: 70
          },
          end: {
            line: 153,
            column: 72
          }
        }],
        line: 153
      },
      "18": {
        loc: {
          start: {
            line: 154,
            column: 8
          },
          end: {
            line: 154,
            column: 41
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 154,
            column: 17
          },
          end: {
            line: 154,
            column: 36
          }
        }, {
          start: {
            line: 154,
            column: 39
          },
          end: {
            line: 154,
            column: 41
          }
        }],
        line: 154
      },
      "19": {
        loc: {
          start: {
            line: 166,
            column: 8
          },
          end: {
            line: 166,
            column: 91
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 166,
            column: 36
          },
          end: {
            line: 166,
            column: 86
          }
        }, {
          start: {
            line: 166,
            column: 89
          },
          end: {
            line: 166,
            column: 91
          }
        }],
        line: 166
      },
      "20": {
        loc: {
          start: {
            line: 167,
            column: 63
          },
          end: {
            line: 167,
            column: 96
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 167,
            column: 72
          },
          end: {
            line: 167,
            column: 91
          }
        }, {
          start: {
            line: 167,
            column: 94
          },
          end: {
            line: 167,
            column: 96
          }
        }],
        line: 167
      },
      "21": {
        loc: {
          start: {
            line: 168,
            column: 8
          },
          end: {
            line: 168,
            column: 47
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 168,
            column: 19
          },
          end: {
            line: 168,
            column: 42
          }
        }, {
          start: {
            line: 168,
            column: 45
          },
          end: {
            line: 168,
            column: 47
          }
        }],
        line: 168
      },
      "22": {
        loc: {
          start: {
            line: 169,
            column: 9
          },
          end: {
            line: 169,
            column: 42
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 169,
            column: 18
          },
          end: {
            line: 169,
            column: 37
          }
        }, {
          start: {
            line: 169,
            column: 40
          },
          end: {
            line: 169,
            column: 42
          }
        }],
        line: 169
      },
      "23": {
        loc: {
          start: {
            line: 184,
            column: 8
          },
          end: {
            line: 190,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 184,
            column: 8
          },
          end: {
            line: 190,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 184
      },
      "24": {
        loc: {
          start: {
            line: 184,
            column: 12
          },
          end: {
            line: 184,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 184,
            column: 12
          },
          end: {
            line: 184,
            column: 41
          }
        }, {
          start: {
            line: 184,
            column: 45
          },
          end: {
            line: 184,
            column: 73
          }
        }],
        line: 184
      },
      "25": {
        loc: {
          start: {
            line: 192,
            column: 25
          },
          end: {
            line: 192,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 192,
            column: 25
          },
          end: {
            line: 192,
            column: 47
          }
        }, {
          start: {
            line: 192,
            column: 51
          },
          end: {
            line: 192,
            column: 66
          }
        }],
        line: 192
      },
      "26": {
        loc: {
          start: {
            line: 220,
            column: 31
          },
          end: {
            line: 220,
            column: 86
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 220,
            column: 60
          },
          end: {
            line: 220,
            column: 62
          }
        }, {
          start: {
            line: 220,
            column: 65
          },
          end: {
            line: 220,
            column: 86
          }
        }],
        line: 220
      },
      "27": {
        loc: {
          start: {
            line: 228,
            column: 29
          },
          end: {
            line: 228,
            column: 91
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 228,
            column: 77
          },
          end: {
            line: 228,
            column: 86
          }
        }, {
          start: {
            line: 228,
            column: 89
          },
          end: {
            line: 228,
            column: 91
          }
        }],
        line: 228
      },
      "28": {
        loc: {
          start: {
            line: 228,
            column: 29
          },
          end: {
            line: 228,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 228,
            column: 29
          },
          end: {
            line: 228,
            column: 42
          }
        }, {
          start: {
            line: 228,
            column: 46
          },
          end: {
            line: 228,
            column: 74
          }
        }],
        line: 228
      },
      "29": {
        loc: {
          start: {
            line: 229,
            column: 8
          },
          end: {
            line: 229,
            column: 91
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 229,
            column: 36
          },
          end: {
            line: 229,
            column: 86
          }
        }, {
          start: {
            line: 229,
            column: 89
          },
          end: {
            line: 229,
            column: 91
          }
        }],
        line: 229
      },
      "30": {
        loc: {
          start: {
            line: 230,
            column: 34
          },
          end: {
            line: 230,
            column: 73
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 230,
            column: 45
          },
          end: {
            line: 230,
            column: 68
          }
        }, {
          start: {
            line: 230,
            column: 71
          },
          end: {
            line: 230,
            column: 73
          }
        }],
        line: 230
      },
      "31": {
        loc: {
          start: {
            line: 231,
            column: 8
          },
          end: {
            line: 231,
            column: 41
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 231,
            column: 17
          },
          end: {
            line: 231,
            column: 36
          }
        }, {
          start: {
            line: 231,
            column: 39
          },
          end: {
            line: 231,
            column: 41
          }
        }],
        line: 231
      },
      "32": {
        loc: {
          start: {
            line: 243,
            column: 8
          },
          end: {
            line: 243,
            column: 91
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 243,
            column: 36
          },
          end: {
            line: 243,
            column: 86
          }
        }, {
          start: {
            line: 243,
            column: 89
          },
          end: {
            line: 243,
            column: 91
          }
        }],
        line: 243
      },
      "33": {
        loc: {
          start: {
            line: 245,
            column: 8
          },
          end: {
            line: 245,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 245,
            column: 21
          },
          end: {
            line: 245,
            column: 44
          }
        }, {
          start: {
            line: 245,
            column: 47
          },
          end: {
            line: 245,
            column: 49
          }
        }],
        line: 245
      },
      "34": {
        loc: {
          start: {
            line: 246,
            column: 10
          },
          end: {
            line: 246,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 246,
            column: 21
          },
          end: {
            line: 246,
            column: 44
          }
        }, {
          start: {
            line: 246,
            column: 47
          },
          end: {
            line: 246,
            column: 49
          }
        }],
        line: 246
      },
      "35": {
        loc: {
          start: {
            line: 246,
            column: 53
          },
          end: {
            line: 246,
            column: 86
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 246,
            column: 62
          },
          end: {
            line: 246,
            column: 81
          }
        }, {
          start: {
            line: 246,
            column: 84
          },
          end: {
            line: 246,
            column: 86
          }
        }],
        line: 246
      },
      "36": {
        loc: {
          start: {
            line: 261,
            column: 8
          },
          end: {
            line: 267,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 261,
            column: 8
          },
          end: {
            line: 267,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 261
      },
      "37": {
        loc: {
          start: {
            line: 261,
            column: 12
          },
          end: {
            line: 261,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 261,
            column: 12
          },
          end: {
            line: 261,
            column: 41
          }
        }, {
          start: {
            line: 261,
            column: 45
          },
          end: {
            line: 261,
            column: 73
          }
        }],
        line: 261
      },
      "38": {
        loc: {
          start: {
            line: 269,
            column: 25
          },
          end: {
            line: 269,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 269,
            column: 25
          },
          end: {
            line: 269,
            column: 47
          }
        }, {
          start: {
            line: 269,
            column: 51
          },
          end: {
            line: 269,
            column: 66
          }
        }],
        line: 269
      },
      "39": {
        loc: {
          start: {
            line: 299,
            column: 40
          },
          end: {
            line: 299,
            column: 51
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 299,
            column: 49
          },
          end: {
            line: 299,
            column: 51
          }
        }],
        line: 299
      },
      "40": {
        loc: {
          start: {
            line: 306,
            column: 27
          },
          end: {
            line: 306,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 306,
            column: 75
          },
          end: {
            line: 306,
            column: 84
          }
        }, {
          start: {
            line: 306,
            column: 87
          },
          end: {
            line: 306,
            column: 89
          }
        }],
        line: 306
      },
      "41": {
        loc: {
          start: {
            line: 306,
            column: 27
          },
          end: {
            line: 306,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 306,
            column: 27
          },
          end: {
            line: 306,
            column: 40
          }
        }, {
          start: {
            line: 306,
            column: 44
          },
          end: {
            line: 306,
            column: 72
          }
        }],
        line: 306
      },
      "42": {
        loc: {
          start: {
            line: 317,
            column: 6
          },
          end: {
            line: 320,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 317,
            column: 6
          },
          end: {
            line: 320,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 317
      },
      "43": {
        loc: {
          start: {
            line: 317,
            column: 10
          },
          end: {
            line: 317,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 317,
            column: 10
          },
          end: {
            line: 317,
            column: 32
          }
        }, {
          start: {
            line: 317,
            column: 36
          },
          end: {
            line: 317,
            column: 57
          }
        }],
        line: 317
      },
      "44": {
        loc: {
          start: {
            line: 330,
            column: 43
          },
          end: {
            line: 330,
            column: 54
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 330,
            column: 52
          },
          end: {
            line: 330,
            column: 54
          }
        }],
        line: 330
      },
      "45": {
        loc: {
          start: {
            line: 336,
            column: 27
          },
          end: {
            line: 336,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 336,
            column: 75
          },
          end: {
            line: 336,
            column: 84
          }
        }, {
          start: {
            line: 336,
            column: 87
          },
          end: {
            line: 336,
            column: 89
          }
        }],
        line: 336
      },
      "46": {
        loc: {
          start: {
            line: 336,
            column: 27
          },
          end: {
            line: 336,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 336,
            column: 27
          },
          end: {
            line: 336,
            column: 40
          }
        }, {
          start: {
            line: 336,
            column: 44
          },
          end: {
            line: 336,
            column: 72
          }
        }],
        line: 336
      },
      "47": {
        loc: {
          start: {
            line: 347,
            column: 6
          },
          end: {
            line: 350,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 347,
            column: 6
          },
          end: {
            line: 350,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 347
      },
      "48": {
        loc: {
          start: {
            line: 347,
            column: 10
          },
          end: {
            line: 347,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 347,
            column: 10
          },
          end: {
            line: 347,
            column: 32
          }
        }, {
          start: {
            line: 347,
            column: 36
          },
          end: {
            line: 347,
            column: 57
          }
        }],
        line: 347
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0e51cd9a03abb23496b7fb482b909969d324c66c"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_deeqi03si = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_deeqi03si();
cov_deeqi03si().s[0]++;
var getBeforeLoadMonthsAction = function getBeforeLoadMonthsAction(productId) {
  cov_deeqi03si().f[0]++;
  cov_deeqi03si().s[1]++;
  return {
    type: 'CALENDAR_BEFORE_LOAD_MONTHS',
    productId: productId
  };
};
cov_deeqi03si().s[2]++;
var getBeforeLoadAction = function getBeforeLoadAction(productId) {
  cov_deeqi03si().f[1]++;
  cov_deeqi03si().s[3]++;
  return {
    type: 'CALENDAR_BEFORE_LOAD',
    productId: productId
  };
};
cov_deeqi03si().s[4]++;
var getBeforeLoadDayAction = function getBeforeLoadDayAction(year, month, day) {
  cov_deeqi03si().f[2]++;
  cov_deeqi03si().s[5]++;
  return {
    type: 'CALENDAR_BEFORE_DAY_LOAD',
    year: year,
    month: month,
    day: day
  };
};
cov_deeqi03si().s[6]++;
var getLoadMonthsSuccessAction = function getLoadMonthsSuccessAction(data, config) {
  cov_deeqi03si().f[3]++;
  cov_deeqi03si().s[7]++;
  return {
    type: 'CALENDAR_LOAD_MONTHS_SUCCESS',
    data: data,
    config: config
  };
};
cov_deeqi03si().s[8]++;
var getLoadMonthSuccessAction = function getLoadMonthSuccessAction(data, year, month, config) {
  cov_deeqi03si().f[4]++;
  cov_deeqi03si().s[9]++;
  return {
    type: 'CALENDAR_LOAD_MONTH_SUCCESS',
    data: data,
    year: year,
    month: month,
    config: config
  };
};
cov_deeqi03si().s[10]++;
var getLoadDaySuccessAction = function getLoadDaySuccessAction(data, year, month, day, config) {
  cov_deeqi03si().f[5]++;
  cov_deeqi03si().s[11]++;
  return {
    type: 'CALENDAR_LOAD_DAY_SUCCESS',
    data: data,
    year: year,
    month: month,
    day: day,
    config: config
  };
};
cov_deeqi03si().s[12]++;
var getLoadErrorAction = function getLoadErrorAction() {
  cov_deeqi03si().f[6]++;
  cov_deeqi03si().s[13]++;
  return {
    type: 'CALENDAR_LOAD_ERROR'
  };
};
cov_deeqi03si().s[14]++;
var getLoadOcurrencesSuccessAction = function getLoadOcurrencesSuccessAction(data, config, useProductDateRange) {
  cov_deeqi03si().f[7]++;
  cov_deeqi03si().s[15]++;
  return {
    type: 'CALENDAR_LOAD_OCURRENCES_SUCCESS',
    data: data,
    config: config,
    useProductDateRange: useProductDateRange
  };
};
cov_deeqi03si().s[16]++;
var getLoadMoreOcurrencesSuccessAction = function getLoadMoreOcurrencesSuccessAction(data, config) {
  cov_deeqi03si().f[8]++;
  cov_deeqi03si().s[17]++;
  return {
    type: 'CALENDAR_LOAD_MORE_OCURRENCES_SUCCESS',
    data: data,
    config: config
  };
};

/*
 * Get the query patch URL for calendar products.
 * If the productId is passed, get only the information of this product, otherwise get information of all products.
 * If a filterCriteria is passed, filter the products by these criteria
 */
cov_deeqi03si().s[18]++;
var getQueryPatchForCalendarUrl = function getQueryPatchForCalendarUrl(productId, config, _ref, withSimplePrices) {
  var _ref$filterCriteria = _ref.filterCriteria,
    filterCriteria = _ref$filterCriteria === void 0 ? (cov_deeqi03si().b[0][0]++, {}) : _ref$filterCriteria;
  cov_deeqi03si().f[9]++;
  var productParam = (cov_deeqi03si().s[19]++, productId ? (cov_deeqi03si().b[1][0]++, "productId=".concat(productId)) : (cov_deeqi03si().b[1][1]++, ''));
  var withTourOnlyParam = (cov_deeqi03si().s[20]++, config.withTourOnly ? (cov_deeqi03si().b[2][0]++, "withTourOnly=".concat(config.withTourOnly)) : (cov_deeqi03si().b[2][1]++, ''));
  var productOwnerParam = (cov_deeqi03si().s[21]++, config.productOwnerNumber ? (cov_deeqi03si().b[3][0]++, "productOwnerNumber=".concat(config.productOwnerNumber)) : (cov_deeqi03si().b[3][1]++, ''));
  var additionalParam = (cov_deeqi03si().s[22]++, withSimplePrices ? (cov_deeqi03si().b[4][0]++, 'additionalFields=prices,simplePrices') : (cov_deeqi03si().b[4][1]++, 'additionalFields=prices'));
  var urlFilterParam = (cov_deeqi03si().s[23]++, (cov_deeqi03si().b[5][0]++, filterCriteria) && (cov_deeqi03si().b[5][1]++, (0, _keys.default)(filterCriteria).reduce(function (acc, filterKey) {
    cov_deeqi03si().f[10]++;
    cov_deeqi03si().s[24]++;
    return filterCriteria[filterKey] ? (cov_deeqi03si().b[6][0]++, "".concat(acc, "&").concat(filterKey, "=").concat(filterCriteria[filterKey])) : (cov_deeqi03si().b[6][1]++, "".concat(acc));
  }, '')));
  var queryPath = (cov_deeqi03si().s[25]++, [productParam, withTourOnlyParam, productOwnerParam, urlFilterParam, additionalParam].filter(Boolean).join('&'));
  cov_deeqi03si().s[26]++;
  return queryPath ? (cov_deeqi03si().b[7][0]++, "?".concat(queryPath)) : (cov_deeqi03si().b[7][1]++, '');
};
cov_deeqi03si().s[27]++;
var REST_URL = function REST_URL(config) {
  cov_deeqi03si().f[11]++;
  cov_deeqi03si().s[28]++;
  return "".concat(config.restHost, "/v1");
};

/*
 * Load the range of months to show.
 * If a product id is passed, take only the occurrence of this product, if not take it over all products on sales.
 */
cov_deeqi03si().s[29]++;
var loadMonths = function loadMonths(config, productId) {
  var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_deeqi03si().b[8][0]++, {});
  cov_deeqi03si().f[12]++;
  cov_deeqi03si().s[30]++;
  return function (dispatch) {
    cov_deeqi03si().f[13]++;
    cov_deeqi03si().s[31]++;
    // first dispatch the beforeLoad action
    dispatch(getBeforeLoadMonthsAction(productId));
    // if a product is passed, pass
    // then fetch the month action
    cov_deeqi03si().s[32]++;
    return (0, _gAxios.default)("".concat(REST_URL(config), "/").concat((cov_deeqi03si().b[10][0]++, config.config) && (cov_deeqi03si().b[10][1]++, config.config.cfcacheEnabled) ? (cov_deeqi03si().b[9][0]++, 'secure/') : (cov_deeqi03si().b[9][1]++, ''), "calendar").concat(getQueryPatchForCalendarUrl(productId, config, filter, false)), {
      headers: config.headers
    }).then(function (response) {
      cov_deeqi03si().f[14]++;
      cov_deeqi03si().s[33]++;
      if ((cov_deeqi03si().b[12][0]++, response.status >= 200) && (cov_deeqi03si().b[12][1]++, response.status < 300)) {
        cov_deeqi03si().b[11][0]++;
        cov_deeqi03si().s[34]++;
        dispatch(getLoadMonthsSuccessAction(response.data, config));
        cov_deeqi03si().s[35]++;
        return response.data;
      } else {
        cov_deeqi03si().b[11][1]++;
      }
      cov_deeqi03si().s[36]++;
      throw response;
    }).catch(function (response) {
      cov_deeqi03si().f[15]++;
      cov_deeqi03si().s[37]++;
      dispatch(getLoadErrorAction());
      cov_deeqi03si().s[38]++;
      (0, _gAxios.logError)((0, _gAxios.getFrontEndErrorFromAxiosError)(response), config.headers, config.widgetInfo, response);
      cov_deeqi03si().s[39]++;
      return response;
    });
  };
};

/*
 * The loader get the product data based on the id of the product we want to get
 * the options contains information we can pass to change the value returned
 * options may contain :
 *        -> productId (MANDATORY), that is obviously the id of the product we want.
 *        -> dateFrom, filter the items from this date
 *        -> dateTo, filter the items until this date
 *        -> offset that is a number to pass for pagination
 *        -> maxAllowedOccurrences, max number of occurrences (max number is 50)
 */
cov_deeqi03si().s[40]++;
var loadOcurrencesProduct = function loadOcurrencesProduct(config, options) {
  cov_deeqi03si().f[16]++;
  cov_deeqi03si().s[41]++;
  return function (dispatch) {
    cov_deeqi03si().f[17]++;
    cov_deeqi03si().s[42]++;
    // first dispatch the beforeLoad action
    dispatch(getBeforeLoadAction());
    var _ref2 = (cov_deeqi03si().s[43]++, options),
      productId = _ref2.productId,
      offset = _ref2.offset,
      dateFrom = _ref2.dateFrom,
      dateTo = _ref2.dateTo,
      maxAllowedOccurrences = _ref2.maxAllowedOccurrences;

    // Parse the max occurrences because only accepts values less than 50
    var parsedMaxOccurrences = (cov_deeqi03si().s[44]++, maxAllowedOccurrences > 50 ? (cov_deeqi03si().b[13][0]++, 50) : (cov_deeqi03si().b[13][1]++, maxAllowedOccurrences));
    // then fetch the product

    /**
     * Fetch the product info for a product id
     */
    cov_deeqi03si().s[45]++;
    var getProductInfo = function getProductInfo() {
      cov_deeqi03si().f[18]++;
      cov_deeqi03si().s[46]++;
      return (0, _gAxios.default)("".concat(REST_URL(config), "/").concat((cov_deeqi03si().b[15][0]++, config.config) && (cov_deeqi03si().b[15][1]++, config.config.cfcacheEnabled) ? (cov_deeqi03si().b[14][0]++, 'secure/') : (cov_deeqi03si().b[14][1]++, ''), "products/").concat(productId, "?maxOccurrences=").concat(parsedMaxOccurrences).concat(config.productOwnerNumber ? (cov_deeqi03si().b[16][0]++, "&productOwnerNumber=".concat(config.productOwnerNumber)) : (cov_deeqi03si().b[16][1]++, ''), "&additionalFields=prices").concat(dateFrom ? (cov_deeqi03si().b[17][0]++, "&fromDate=".concat(dateFrom)) : (cov_deeqi03si().b[17][1]++, '')).concat(dateTo ? (cov_deeqi03si().b[18][0]++, "&toDate=".concat(dateTo)) : (cov_deeqi03si().b[18][1]++, '')), {
        headers: config.headers
      });
    };
    /**
     * Fetch the occurrences(timeslots/performances) info for a product id
     */
    cov_deeqi03si().s[47]++;
    var getOccurrencesInfo = function getOccurrencesInfo() {
      cov_deeqi03si().f[19]++;
      cov_deeqi03si().s[48]++;
      return (0, _gAxios.default)("".concat(REST_URL(config), "/occurrences?productId=").concat(productId).concat(config.productOwnerNumber ? (cov_deeqi03si().b[19][0]++, "&productOwnerNumber=".concat(config.productOwnerNumber)) : (cov_deeqi03si().b[19][1]++, ''), "&limit=").concat(parsedMaxOccurrences, "&additionalFields=prices").concat(offset ? (cov_deeqi03si().b[20][0]++, "&offset=".concat(offset)) : (cov_deeqi03si().b[20][1]++, '')).concat(dateFrom ? (cov_deeqi03si().b[21][0]++, "&fromDate=".concat(dateFrom)) : (cov_deeqi03si().b[21][1]++, '')).concat(dateTo ? (cov_deeqi03si().b[22][0]++, "&toDate=".concat(dateTo)) : (cov_deeqi03si().b[22][1]++, '')), {
        headers: config.headers
      });
    };
    cov_deeqi03si().s[49]++;
    return _gAxios.default.all([getProductInfo(), getOccurrencesInfo()]).then(_gAxios.default.spread(function (productResponse, occurrenceResponse) {
      cov_deeqi03si().f[20]++;
      var _ref3 = (cov_deeqi03si().s[50]++, productResponse.data),
        product = _ref3.product;
      var _ref4 = (cov_deeqi03si().s[51]++, occurrenceResponse.data),
        performances = _ref4.performances,
        timeslots = _ref4.timeslots;
      cov_deeqi03si().s[52]++;
      product.performances = performances;
      cov_deeqi03si().s[53]++;
      product.timeslots = timeslots;
      cov_deeqi03si().s[54]++;
      if ((cov_deeqi03si().b[24][0]++, productResponse.status >= 200) && (cov_deeqi03si().b[24][1]++, productResponse.status < 300)) {
        cov_deeqi03si().b[23][0]++;
        var state = (cov_deeqi03si().s[55]++, dispatch(getLoadOcurrencesSuccessAction(product, config)));
        cov_deeqi03si().s[56]++;
        return {
          data: productResponse,
          state: state
        };
      } else {
        cov_deeqi03si().b[23][1]++;
      }
      var error = (cov_deeqi03si().s[57]++, new Error("".concat(productResponse.status, " (").concat(productResponse.statusText, ")")));
      cov_deeqi03si().s[58]++;
      error.response = (cov_deeqi03si().b[25][0]++, productResponse.json()) || (cov_deeqi03si().b[25][1]++, productResponse);
      cov_deeqi03si().s[59]++;
      throw error;
    })).catch(function (response) {
      cov_deeqi03si().f[21]++;
      cov_deeqi03si().s[60]++;
      dispatch(getLoadErrorAction());
      cov_deeqi03si().s[61]++;
      (0, _gAxios.logError)((0, _gAxios.getFrontEndErrorFromAxiosError)(response), config.headers, config.widgetInfo, response);
      cov_deeqi03si().s[62]++;
      return response;
    });
  };
};

/**
 * Get the nexts occurrences for a product id
 * @param {object} config , config object to do the request
 * @param {object} options, includes the nexts elements:
 *        -> productId (MANDATORY), that is obviously the id of the product we want.
 *        -> dateFrom, filter the items from this date
 *        -> dateTo, filter the items until this date
 *        -> maxAllowedOccurrences, max number of occurrences (max number is 50)
 *        -> offset that is a number to pass for pagination
 */
cov_deeqi03si().s[63]++;
var loadMoreOcurrencesProduct = function loadMoreOcurrencesProduct(config, options) {
  cov_deeqi03si().f[22]++;
  cov_deeqi03si().s[64]++;
  return function (dispatch, getState) {
    cov_deeqi03si().f[23]++;
    cov_deeqi03si().s[65]++;
    // first dispatch the beforeLoad action
    dispatch(getBeforeLoadAction());
    var _ref5 = (cov_deeqi03si().s[66]++, options),
      productId = _ref5.productId,
      dateFrom = _ref5.dateFrom,
      dateTo = _ref5.dateTo,
      maxAllowedOccurrences = _ref5.maxAllowedOccurrences;
    var _ref6 = (cov_deeqi03si().s[67]++, getState()),
      offset = _ref6.offset;
    // Parse the max occurrences because only accepts values less than 50
    var parsedMaxOccurrences = (cov_deeqi03si().s[68]++, maxAllowedOccurrences > 50 ? (cov_deeqi03si().b[26][0]++, 50) : (cov_deeqi03si().b[26][1]++, maxAllowedOccurrences));
    var pagination = (cov_deeqi03si().s[69]++, ((0, _parseInt2.default)(offset, 10) + 1) * (0, _parseInt2.default)(parsedMaxOccurrences, 10));

    /**
     * Fetch the product info for a product id
     */
    cov_deeqi03si().s[70]++;
    var getProductInfo = function getProductInfo() {
      cov_deeqi03si().f[24]++;
      cov_deeqi03si().s[71]++;
      return (0, _gAxios.default)("".concat(REST_URL(config), "/").concat((cov_deeqi03si().b[28][0]++, config.config) && (cov_deeqi03si().b[28][1]++, config.config.cfcacheEnabled) ? (cov_deeqi03si().b[27][0]++, 'secure/') : (cov_deeqi03si().b[27][1]++, ''), "products/").concat(productId, "?maxOccurrences = ").concat(parsedMaxOccurrences, " ").concat(config.productOwnerNumber ? (cov_deeqi03si().b[29][0]++, "&productOwnerNumber=".concat(config.productOwnerNumber)) : (cov_deeqi03si().b[29][1]++, ''), "& additionalFields=prices").concat(dateFrom ? (cov_deeqi03si().b[30][0]++, "&fromDate=".concat(dateFrom)) : (cov_deeqi03si().b[30][1]++, ''), " ").concat(dateTo ? (cov_deeqi03si().b[31][0]++, "&toDate=".concat(dateTo)) : (cov_deeqi03si().b[31][1]++, ''), " "), {
        headers: config.headers
      });
    };
    /**
     * Fetch the occurrences(timeslots/performances) info for a product id
     */
    cov_deeqi03si().s[72]++;
    var getOccurrencesInfo = function getOccurrencesInfo() {
      cov_deeqi03si().f[25]++;
      cov_deeqi03si().s[73]++;
      return (0, _gAxios.default)("".concat(REST_URL(config), "/ occurrences ? productId = ").concat(productId, " ").concat(config.productOwnerNumber ? (cov_deeqi03si().b[32][0]++, "&productOwnerNumber=".concat(config.productOwnerNumber)) : (cov_deeqi03si().b[32][1]++, ''), "& limit=").concat(parsedMaxOccurrences, "& additionalFields=prices").concat(pagination ? (cov_deeqi03si().b[33][0]++, "&offset=".concat(pagination)) : (cov_deeqi03si().b[33][1]++, ''), " ").concat(dateFrom ? (cov_deeqi03si().b[34][0]++, "&fromDate=".concat(dateFrom)) : (cov_deeqi03si().b[34][1]++, ''), " ").concat(dateTo ? (cov_deeqi03si().b[35][0]++, "&toDate=".concat(dateTo)) : (cov_deeqi03si().b[35][1]++, ''), " "), {
        headers: config.headers
      });
    };
    cov_deeqi03si().s[74]++;
    return _gAxios.default.all([getProductInfo(), getOccurrencesInfo()]).then(_gAxios.default.spread(function (productResponse, occurrenceResponse) {
      cov_deeqi03si().f[26]++;
      var _ref7 = (cov_deeqi03si().s[75]++, productResponse.data),
        product = _ref7.product;
      var _ref8 = (cov_deeqi03si().s[76]++, occurrenceResponse.data),
        performances = _ref8.performances,
        timeslots = _ref8.timeslots;
      cov_deeqi03si().s[77]++;
      product.performances = performances;
      cov_deeqi03si().s[78]++;
      product.timeslots = timeslots;
      cov_deeqi03si().s[79]++;
      if ((cov_deeqi03si().b[37][0]++, productResponse.status >= 200) && (cov_deeqi03si().b[37][1]++, productResponse.status < 300)) {
        cov_deeqi03si().b[36][0]++;
        var state = (cov_deeqi03si().s[80]++, dispatch(getLoadMoreOcurrencesSuccessAction(product, config)));
        cov_deeqi03si().s[81]++;
        return {
          data: productResponse,
          state: state
        };
      } else {
        cov_deeqi03si().b[36][1]++;
      }
      var error = (cov_deeqi03si().s[82]++, new Error("".concat(productResponse.status, " (").concat(productResponse.statusText, ")")));
      cov_deeqi03si().s[83]++;
      error.response = (cov_deeqi03si().b[38][0]++, productResponse.json()) || (cov_deeqi03si().b[38][1]++, productResponse);
      cov_deeqi03si().s[84]++;
      throw error;
    })).catch(function (response) {
      cov_deeqi03si().f[27]++;
      cov_deeqi03si().s[85]++;
      dispatch(getLoadErrorAction());
      cov_deeqi03si().s[86]++;
      (0, _gAxios.logError)((0, _gAxios.getFrontEndErrorFromAxiosError)(response), config.headers, config.widgetInfo, response);
      cov_deeqi03si().s[87]++;
      return response;
    });
  };
};

/**
 * Create the state from a product when it is loaded from another nucleo
 * The productData must be data as received from the server
 * @param {configType} config, the config nucleo type
 * @param {productData} productData, the data of a product like received by the server
 * @param {boolean} useProductDateRange, condition to set calendarRange from productDateRange or not
 */
cov_deeqi03si().s[88]++;
var setOccurrenceProduct = function setOccurrenceProduct(config, productData, useProductDateRange) {
  cov_deeqi03si().f[28]++;
  cov_deeqi03si().s[89]++;
  return function (dispatch) {
    cov_deeqi03si().f[29]++;
    cov_deeqi03si().s[90]++;
    // set the productId in the state
    dispatch(getBeforeLoadMonthsAction(productData.id));
    // set the product data like range into the calendar
    cov_deeqi03si().s[91]++;
    return dispatch(getLoadOcurrencesSuccessAction(productData, config, useProductDateRange));
  };
};

/*
 * Load the range of months to show.
 * If a product id is passed, take only the occurrence of this product, if not take it over all products on sales.
 */
cov_deeqi03si().s[92]++;
var loadMonth = function loadMonth(config, year, month) {
  var filter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (cov_deeqi03si().b[39][0]++, {});
  var withSimplePrices = arguments.length > 4 ? arguments[4] : undefined;
  cov_deeqi03si().f[30]++;
  cov_deeqi03si().s[93]++;
  return function (dispatch, getState) {
    cov_deeqi03si().f[31]++;
    cov_deeqi03si().s[94]++;
    // first dispatch the beforeLoad action
    dispatch(getBeforeLoadAction());
    // if a product is passed, pass
    var productId = (cov_deeqi03si().s[95]++, getState().productId);
    // then fetch the month action, the month on server is 1 to 12, on client side is 0 to 11, so + 1 to the month
    cov_deeqi03si().s[96]++;
    return (0, _gAxios.default)("".concat(REST_URL(config), "/").concat((cov_deeqi03si().b[41][0]++, config.config) && (cov_deeqi03si().b[41][1]++, config.config.cfcacheEnabled) ? (cov_deeqi03si().b[40][0]++, 'secure/') : (cov_deeqi03si().b[40][1]++, ''), "calendar/").concat(year, "/").concat(month + 1).concat(getQueryPatchForCalendarUrl(productId, config, filter, withSimplePrices)), {
      headers: config.headers
    }).then(function (response) {
      cov_deeqi03si().f[32]++;
      cov_deeqi03si().s[97]++;
      if ((cov_deeqi03si().b[43][0]++, response.status >= 200) && (cov_deeqi03si().b[43][1]++, response.status < 300)) {
        cov_deeqi03si().b[42][0]++;
        cov_deeqi03si().s[98]++;
        dispatch(getLoadMonthSuccessAction(response.data, year, month, config));
        cov_deeqi03si().s[99]++;
        return response.data;
      } else {
        cov_deeqi03si().b[42][1]++;
      }
      cov_deeqi03si().s[100]++;
      throw response;
    }).catch(function (response) {
      cov_deeqi03si().f[33]++;
      cov_deeqi03si().s[101]++;
      dispatch(getLoadErrorAction());
      cov_deeqi03si().s[102]++;
      (0, _gAxios.logError)((0, _gAxios.getFrontEndErrorFromAxiosError)(response), config.headers, config.widgetInfo, response);
      cov_deeqi03si().s[103]++;
      return response;
    });
  };
};
cov_deeqi03si().s[104]++;
var loadDay = function loadDay(config, year, month, day) {
  var filter = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : (cov_deeqi03si().b[44][0]++, {});
  var withSimplePrices = arguments.length > 5 ? arguments[5] : undefined;
  cov_deeqi03si().f[34]++;
  cov_deeqi03si().s[105]++;
  return function (dispatch, getState) {
    cov_deeqi03si().f[35]++;
    cov_deeqi03si().s[106]++;
    // first dispatch the beforeLoad action
    dispatch(getBeforeLoadDayAction(year, month, day));
    // if a product is passed, pass
    // then fetch the month action, the month on server is 1 to 12, on client side is 0 to 11, so + 1 to the month
    cov_deeqi03si().s[107]++;
    return (0, _gAxios.default)("".concat(REST_URL(config), "/").concat((cov_deeqi03si().b[46][0]++, config.config) && (cov_deeqi03si().b[46][1]++, config.config.cfcacheEnabled) ? (cov_deeqi03si().b[45][0]++, 'secure/') : (cov_deeqi03si().b[45][1]++, ''), "calendar/").concat(year, "/").concat(month + 1, "/").concat(day).concat(getQueryPatchForCalendarUrl(getState().productId, config, filter, withSimplePrices)), {
      headers: config.headers
    }).then(function (response) {
      cov_deeqi03si().f[36]++;
      cov_deeqi03si().s[108]++;
      if ((cov_deeqi03si().b[48][0]++, response.status >= 200) && (cov_deeqi03si().b[48][1]++, response.status < 300)) {
        cov_deeqi03si().b[47][0]++;
        cov_deeqi03si().s[109]++;
        dispatch(getLoadDaySuccessAction(response.data, year, month, day, config));
        cov_deeqi03si().s[110]++;
        return response.data;
      } else {
        cov_deeqi03si().b[47][1]++;
      }
      cov_deeqi03si().s[111]++;
      throw response;
    }).catch(function (response) {
      cov_deeqi03si().f[37]++;
      cov_deeqi03si().s[112]++;
      dispatch(getLoadErrorAction());
      cov_deeqi03si().s[113]++;
      (0, _gAxios.logError)((0, _gAxios.getFrontEndErrorFromAxiosError)(response), config.headers, config.widgetInfo, response);
      cov_deeqi03si().s[114]++;
      return response;
    });
  };
};
var _default = exports.default = {
  loadMonths: loadMonths,
  loadMonth: loadMonth,
  loadDay: loadDay,
  loadOcurrencesProduct: loadOcurrencesProduct,
  setOccurrenceProduct: setOccurrenceProduct,
  loadMoreOcurrencesProduct: loadMoreOcurrencesProduct
};